import ImageUploadAdapter from "./imageuploadadapter";
  
export default ImageUploadAdapter;
